"use client";

import { useLocale } from "next-intl";
import dynamic from "next/dynamic";
import { getDefaultLayoutConfig } from "@app/defaultLayoutConfig";
import { usePathname } from "@i18n/routing";
import { Box } from "@ecco/ui/box";
import { FullBleed } from "@ecco/ui/full-bleed";
import type { CountdownTimerModel } from "@lib/contentful/mappers/mapCountdownTimer";
import type { ReactElement, ReactNode } from "react";

const BackToTop = dynamic(() => import("@components/ui/backToTop/BackToTop"), { ssr: false });

export const LayoutUSPBanner = dynamic(() =>
    import("@components/ui/USPbanner/USPbanner").then((mod) => mod.USPbanner)
);
const CountdownTimer = dynamic(() =>
    import("@components/ui/countdown-timer/CountdownTimer").then((mod) => mod.CountdownTimer)
);

export function LayoutBackground({ children }: { children: ReactNode }): ReactElement {
    const pathname = usePathname();
    const { hasSubtleBackground } = getDefaultLayoutConfig(String(pathname));

    return (
        <Box
            data-testid="default-layout"
            backgroundColor={hasSubtleBackground ? "gray.50" : undefined}
        >
            {children}
        </Box>
    );
}

export function LayoutCountdown({
    countdownTimer,
}: {
    countdownTimer: CountdownTimerModel;
}): ReactElement | null {
    const pathname = usePathname();
    const { isCountdownTimerVisible } = getDefaultLayoutConfig(String(pathname));

    return isCountdownTimerVisible ? <CountdownTimer countdownTimer={countdownTimer} /> : null;
}

export function LayoutBackToTop(): ReactElement | null {
    const pathname = usePathname();
    const { isBackToTopVisible } = getDefaultLayoutConfig(String(pathname));

    return isBackToTopVisible ? <BackToTop /> : null;
}

export function LayoutKlarnaPlacement(): ReactElement {
    const locale = useLocale();

    return (
        <FullBleed>
            <klarna-placement
                data-testid="klarna-placement"
                data-key="top-strip-promotion-auto-size"
                data-locale={locale}
                data-purchase-amount="0"
            />
        </FullBleed>
    );
}
